import { render, staticRenderFns } from "./OrderTypeTable.vue?vue&type=template&id=b537dc88"
import script from "./OrderTypeTable.vue?vue&type=script&lang=js"
export * from "./OrderTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports